export const encode = (data: any) => {
  return btoa(JSON.stringify(data));
};

export const decode = (data: any) => {
  try {
    return JSON.parse(atob(data));
  } catch (error) {
    return null;
  }
};
